import script from "./Menu-wap.vue?vue&type=script&lang=ts&setup=true"
export * from "./Menu-wap.vue?vue&type=script&lang=ts&setup=true"

import "./Menu-wap.vue?vue&type=style&index=0&id=55ff474a&lang=css"
import "./Menu-wap.vue?vue&type=style&index=1&id=55ff474a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55ff474a"]])

export default __exports__